export const COINBASE = "Coinbase";
export const METAMASK = "MetaMask";
export const VENLY = "Venly";
export const WALLETCONNECT = "WalletConnect";
export const LEDGER = "Ledger";
export const PHANTOM = "Phantom";
